module.exports = __webpack_public_path__ + "static/media/404_PageNotFound.ce9d1188.svg";